import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { SalesService } from 'src/app/api/sale/sales.service';
import { debounce } from 'lodash';
import { ProductService } from 'src/app/api/catalog/product.service';
import { WarehouseService } from 'src/app/api/config/warehouse.service';
import { constants } from 'src/app/constants';
import { ToolsService } from 'src/app/utils/tools.service';
import * as moment from 'moment';
import { GeneralService } from 'src/app/api/config/general.service';
import SwalAlert from 'src/app/utils/swalalert';
import { SearchClientComponent } from 'src/app/components/search-client/search-client.component';
import { ClientExtendsComponent } from '../../client/client-extends/client-extends.component';
declare var $: any;
import Swal from 'sweetalert2';
import { ProductPriceunitsExtendsComponent } from 'src/app/catalog/product/product-priceunits-extends/product-priceunits-extends.component';
import { ProductInformationdetailExtendsComponent } from 'src/app/catalog/product/product-informationdetail-extends/product-informationdetail-extends.component';
import { AmountTextService } from 'src/app/utils/amount-text.service';
import { AccountbankService } from 'src/app/api/finance/accountbank.service';
import { HotelbookingsExtendsComponent } from 'src/app/hotelbooking/hotelbookings/hotelbookings-extends/hotelbookings-extends.component';

@Component({
  selector: 'app-sales-form',
  templateUrl: './sales-form.component.html',
  styleUrls: ['./sales-form.component.css']
})
export class SalesFormComponent implements OnInit {
  @ViewChild(SearchClientComponent) SearchClientComponent: any;
  @ViewChild(ClientExtendsComponent) ClientExtendsComponent: any;
  @ViewChild(ProductPriceunitsExtendsComponent)
  ProductPriceunitsExtendsComponent: any;
  @ViewChild(ProductInformationdetailExtendsComponent)
  ProductInformationdetailExtendsComponent: any;
  @ViewChild(HotelbookingsExtendsComponent)
  HotelbookingsExtendsComponent: any;

  private thisComponent: SalesFormComponent;

  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  page = 1;
  count = 0;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  segment_prices: any = constants.PRODUCT.SEGMENTPRICES;

  // variables
  date_sale: any = moment().format('YYYY-MM-DD');
  textSearchProduct: any = null;
  warehousesSelected: any = null;
  products: any = [];
  exist_favorites: boolean = false;
  typeprice_general: any = constants.PRODUCT.TYPEPRICE[0].id;
  typeprice_unit: any = constants.PRODUCT.TYPEPRICE[1].id;

  quantity_default: number = 1;
  details: any = [];
  igvSelected: any = null;

  subtotal: any = 0;
  total_igv: any = 0;
  total_sale: any = 0;
  total_received: any = 0;
  total_change: any = 0;

  warehouses: any = [];
  transactions: any = [];
  typevouchers: any = [];
  series: any = [];
  paymentmethods: any = [];
  currencies: any = [];
  originsales: any = [];
  virtualchannels: any = [];
  originsale_virtual: any = 2;
  accountbanks: any = [];

  typeVoucherSelected: any = null;
  serieSelected: any = null;
  paymentMethodSelected: any = null;

  isClientSelected: boolean = false;
  clientSelected: any = {};
  client_default: boolean = false;

  typevoucher_boleta: any = null;
  typevoucher_factura: any = null;

  movement: any = {
    paymentmethod_id: null,
    typevoucher_id: null,
    currency_id: null,
    accountbank_id: null,
    serie: null,
    is_paid: false,
    document: null,
    address: null,
    reference_operation: null,
    text_amount: null
  };

  // configuracion de sucursal ===
  isHotel: boolean = true;
  hotelBookingSelected: any = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private generalService: GeneralService,
    private warehouseService: WarehouseService,
    private salesService: SalesService,
    private productService: ProductService,
    private accountbankService: AccountbankService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert,
    private amountTextService: AmountTextService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      client_id: [null],
      bookinghotel_id: [null],
      detailbedroom_id: [null],
      typetransaction_id: [null],
      origin_id: [1],
      channel_id: [null],
      order_id: [null],
      proforma_id: [null],
      is_igv: [false],
      is_grouped: [false],
      description_grouped: [null],
      is_order: [false],
      is_proforma: [false],
      igv: [null],
      subtotal: [null],
      total: [null]
    });

    this.typevoucher_boleta = this.toolsService.searchObjByKey(
      'BOLETA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_factura = this.toolsService.searchObjByKey(
      'FACTURA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
      this.salesService.get(this.checkId).subscribe({
        next: (data: any) => {
          this.item.patchValue({
            description: data.data.description
          });
        }
      });
    }
  }

  ngOnInit() {
    // this.searchAction();
    // this.getTax();
    // this.getTypeTransactions();
    // this.getTypeVoucherSale();
    // this.getCurrencies();
    // this.getPaymentmethods();
    // this.getOriginSales();
    // this.getVirtualChannels();
    this.getPreviewData();
    // this.getWarehousePrincipal();
    this.getAccountBanks();
    this.navigationTrackerService.initializeMenu(this.route);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getPreviewData() {
    this.salesService.previewDataForm().subscribe({
      next: (data: any) => {
        this.igvSelected = data.tax[0];
        this.warehouses = data.warehouses;
        this.transactions = data.transactions;
        this.transactions = data.transactions;
        this.currencies = data.currencies;
        this.typevouchers = data.typevouchers;
        this.paymentmethods = data.paymentmethods;
        this.originsales = data.originsales;
        this.virtualchannels = data.virtualchannels;

        this.item.patchValue({
          typetransaction_id: this.transactions[0].id
        });

        for (let i in this.currencies) {
          if (this.currencies[i].is_principal) {
            this.movement.currency_id = this.currencies[i].id;
          }
        }

        this.movement.paymentmethod_id = this.paymentmethods[0].id;
        this.paymentMethodSelected = this.paymentmethods[0];
        this.movement.typevoucher_id = this.typevouchers[0].id;
        this.typeVoucherSelected = this.typevouchers[0];
        this.getSerieVoucher(this.movement.typevoucher_id);

        // asignar almacen principal  =====
        for (let i in this.warehouses) {
          if (this.warehouses[i].is_principal) {
            this.warehousesSelected = this.warehouses[i];
            this.searchAction();
          }
        }
      }
    });
  }

  getWarehousePrincipal() {
    this.warehouseService.listWarehouseBranchoffice().subscribe({
      next: (data: any) => {
        this.warehouses = data.results;
        for (let i in this.warehouses) {
          if (this.warehouses[i].is_principal) {
            this.warehousesSelected = this.warehouses[i];
          }
        }
        // this.warehousesSelected = data.results;
      }
    });
  }

  getTax() {
    this.generalService.listTax().subscribe({
      next: (data: any) => {
        this.igvSelected = data.results[0];
      }
    });
  }

  getTypeTransactions() {
    this.generalService.listTypeTransactions().subscribe({
      next: (data: any) => {
        this.transactions = data.results;
        this.item.patchValue({
          typetransaction_id: this.transactions[0].id
        });
      }
    });
  }

  getCurrencies() {
    this.generalService.listCurrencies().subscribe({
      next: (data: any) => {
        this.currencies = data.results;
        for (let i in this.currencies) {
          if (this.currencies[i].is_principal) {
            this.movement.currency_id = this.currencies[i].id;
          }
        }
      }
    });
  }

  getTypeVoucherSale() {
    this.generalService.listTypeVoucherSale().subscribe({
      next: (data: any) => {
        this.typevouchers = data.results;
        this.movement.typevoucher_id = this.typevouchers[0].id;
        this.typeVoucherSelected = this.typevouchers[0];
        this.getSerieVoucher(this.movement.typevoucher_id);
      }
    });
  }

  getSerieVoucher(typevoucher_id: any) {
    this.generalService.getSerieTypeVoucher(typevoucher_id).subscribe({
      next: (data: any) => {
        this.series = data.results;
        this.movement.serie = this.series[0].series;
        this.serieSelected = this.series[0];
      }
    });
  }

  getPaymentmethods() {
    this.generalService.listPaymentmethods().subscribe({
      next: (data: any) => {
        this.paymentmethods = data.results;
        this.movement.paymentmethod_id = this.paymentmethods[0].id;
        this.paymentMethodSelected = this.paymentmethods[0];
      }
    });
  }

  getOriginSales() {
    this.generalService.listOriginSales().subscribe({
      next: (data: any) => {
        this.originsales = data.results;
      }
    });
  }

  getVirtualChannels() {
    this.generalService.listVirtualChannels().subscribe({
      next: (data: any) => {
        this.virtualchannels = data.results;
      }
    });
  }

  getAccountBanks() {
    this.accountbankService.all().subscribe({
      next: (data: any) => {
        this.accountbanks = data.results;
      }
    });
  }

  changeWarehouseSelected() {
    let val_ = (<any>$('#warehousesSelected')).val();
    if (this.details.length > 0) {
      let options = {
        title: '¿Estás segur@?',
        message:
          'Al cambiar el origen de almacén, se va quitar el detalle de productos seleccionados',
        cancel: 'Cancelar',
        confirm: 'Cambiar Almacén'
      };
      this.alert.confirmCheckinInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          let item_ = this.toolsService.searchObjById(val_, this.warehouses);
          this.warehousesSelected = item_;
          this.products = [];
          this.details = [];
          this.searchAction();
          this.recalculateTotalSale();
        }
      });
    } else {
      let item_ = this.toolsService.searchObjById(val_, this.warehouses);
      this.warehousesSelected = item_;
      this.searchAction();
      this.recalculateTotalSale();
    }
  }

  changeBankAccount(param: any) {
    let value_ = param.value;
    if (value_ == 'null') {
      value_ = null;
    }
    this.movement.accountbank_id = value_;
  }

  debouncedSearch = debounce(
    event => this.searchAction(event.target.value),
    250
  );

  searchAction(text: any = null) {
    let val_params =
      'search=' +
      text +
      '&page=' +
      this.page +
      '&warehouse_id=' +
      this.warehousesSelected.id;

    if (text != null) {
      this.exist_favorites = false;
      this.page = 1;
      this.productService.searchSale(val_params).subscribe({
        next: (data: any) => {
          this.products = data.results;
          // this.dataPagination.pageSize = data.paginate_by;
          // this.dataPagination.currentPage = this.page;
          // this.dataPagination.totalItems = data.total;
          // console.log(this.products);
        }
      });
    } else {
      this.exist_favorites = true;
      this.productService.listFavorite(val_params).subscribe({
        next: (data: any) => {
          this.products = data.results;
          this.dataPagination.pageSize = data.paginate_by;
          this.dataPagination.currentPage = this.page;
          this.dataPagination.totalItems = data.total;
          // console.log(this.products);
        }
      });
    }
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.searchAction();
  }

  resetSearchProducts() {
    this.products = [];
    this.textSearchProduct = null;
    (<any>$('#searchProducts')).focus();
    this.searchAction();
  }

  addProduct(item: any) {
    if (this.validExistStock(item)) {
      if (this.ifExistItem(item)) {
        item.detail_id = null;
        item.quantity = this.quantity_default;
        item.price = item.price_sale;
        item.igv = null;
        item.is_renewal = false;
        item.date_renewal = null;

        item.unit_id = item.unitsmeasure[0].id;
        item.warehouse_id = this.warehousesSelected.id;
        item.segmentpriceproduct_id = this.toolsService.searchObjByKey(
          'price_sale',
          this.segment_prices
        ).id;

        let subtotal_ = Number(
          Number(item.price) * Number(item.quantity)
        ).toFixed(2);
        item.subtotal = subtotal_;
        this.details.push(item);
        this.recalculateTotalSale();

        setTimeout(() => {
          (<any>$('[data-toggle="tooltip"]')).tooltip();
        }, 150);
      } else {
        this.alertifyMsg.warning(
          'El producto ' + item.description + ' ya se encuentra agregado'
        );
      }
    }
  }

  ifExistItem(product: any) {
    let response = false;
    if (this.toolsService.notExistObjInArr(product, this.details)) {
      response = true;
    }
    return response;
  }

  validExistStock(product: any) {
    let validate_ = true;
    if (product.is_control_stock) {
      for (let i in product.productstock) {
        let stock = product.productstock[i];
        if (
          stock.warehouse_id == this.warehousesSelected.id &&
          stock.stock == 0
        ) {
          this.alertifyMsg.warning(
            'El producto ' +
              product.description +
              ' no cuenta con stock suficiente en el almacén ' +
              this.warehousesSelected.description
          );
          validate_ = false;
          return false;
        }
      }
    }
    return validate_;
  }

  openAccordion(val_id: any) {
    $('.accordion-box' + val_id)
      .parent('.accordion-item')
      .find('.accordion-contant')
      .slideToggle({
        duration: 200
      });
    $('.accordion-box' + val_id)
      .parent('.accordion-item')
      .prevAll('.accordion-item')
      .find('.accordion-contant')
      .slideUp(10);
    $('.accordion-box' + val_id)
      .parent('.accordion-item')
      .nextAll('.accordion-item')
      .find('.accordion-contant')
      .slideUp(10);
  }

  changeQuantity(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.details[index].quantity = value_;
      this.changeSubtotal(index);
    }
  }

  changeQuantityByButton(amount: number, index: number) {
    let qty = parseFloat(this.details[index].quantity) || 0;
    qty += amount;
    if (qty < 0) qty = 0; // evitar negativos
    this.details[index].quantity = qty.toFixed(2);
    this.changeSubtotal(index);
  }

  changePrice(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.details[index].price = value_;
      this.changeSubtotal(index);
    }
  }

  changeUnitSelected(param: any, index: number, product: any): void {
    let value_ = param.value;
    let unitselected_ = this.toolsService.searchObjById(
      value_,
      product.unitsmeasure
    );
    this.details[index].unit_id = unitselected_.id;
    this.details[index].price = unitselected_.price_sale;
    this.changeSubtotal(index);
  }

  changeSubtotal(index: any) {
    let subtotal_ = this.details[index].price * this.details[index].quantity;
    this.details[index].subtotal = Number(subtotal_).toFixed(2);
    this.recalculateTotalSale();
  }

  removeProduct(index: any) {
    this.alertifyMsg.warning(
      'El producto ' +
        this.details[index].description +
        ' ha sido removido del detalle'
    );
    this.details.splice(index, 1);
    this.recalculateTotalSale();
  }

  recalculateTotalSale() {
    let total_ = 0;
    for (let i in this.details) {
      let item_ = this.details[i];
      total_ = total_ + Number(item_.subtotal);
    }
    this.subtotal = Number(total_).toFixed(2);
    this.total_igv = Number(0).toFixed(2);
    this.total_sale = this.subtotal;
  }

  recalculateDifferenceMoney(param: any): void {
    let value_ = param.value;
    this.total_received = value_;
    if (!_.isNaN(value_ * 1)) {
      if (Number(this.total_received) > Number(this.total_sale)) {
        this.total_change = (
          Number(this.total_received) - Number(this.total_sale)
        ).toFixed(2);
      } else {
        this.total_change = 0;
      }
    }
  }

  selectedClientSearch(item_: any) {
    this.isClientSelected = true;
    this.clientSelected = item_;
    this.item.patchValue({
      client_id: item_.id,
      tel_1: item_.cellphone,
      tel_2: item_.telephone
    });
  }

  removeClient() {
    this.isClientSelected = false;
    this.clientSelected = {};
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  extendsClient(event: any): void {
    this.selectedClientSearch(event);
  }

  savePaid() {
    // if (this.item.invalid) {
    //   return;
    // }

    if (this.validate()) {
      let options = {
        title: '¿Estás segur@?',
        message: 'Esta seguro(a) de confirmar el pago de la venta?',
        cancel: 'Cancelar',
        confirm: 'Sí, CONFIRMAR VENTA !'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.submitted = true;
          this.onSubmit();
        }
      });
    }
  }

  onSubmit() {
    this.movement.client_default = this.client_default;
    this.movement.text_amount = this.amountTextService.letras(this.total_sale);

    this.item.patchValue({
      igv: this.total_igv,
      subtotal: this.subtotal,
      total: this.total_sale
    });

    let data: any = {};
    data.sale = this.item.value;
    data.paid = this.movement;
    data.detail = this.details;

    if (this.isEdit) {
      // this.salesService.update(this.checkId, this.item.value).subscribe({
      //   next: (data: any) => {
      //     this.alertifyMsg.success('Registro actualizado con éxito');
      //     this.cancel();
      //   }
      // });
    } else {
      this.salesService.save(data).subscribe({
        next: (result: any) => {
          this.alertifyMsg.success('Registro realizado con éxito');
          let sale_ = result.sale;
          let movement_ = result.movement;

          if (result.billing != false) {
            var billing = result.billing;
            var label;
            label =
              '<span class="badge badge-success f-s-12 p-5">' +
              billing.message +
              '</span>';

            if (billing.code == 'pending') {
              label =
                '<span class="badge badge-warning f-s-12 p-5">' +
                billing.message +
                '</span>';
            }

            Swal.fire({
              title: 'EN HORA BUENA!',
              html:
                '<b>Venta registrada correctamente</b>, desea imprimir el comprobante?</br></br>' +
                label +
                ' ',
              icon: 'success',
              showCancelButton: true,
              confirmButtonColor: '#30419B',
              cancelButtonColor: '#787171',
              confirmButtonText: 'Imprimir <i class="fas fa-print m-r-5"></i>',
              cancelButtonText: 'Cancelar'
            }).then(result => {
              if (result.isConfirmed) {
                window.open(
                  this.branchofficeSlug +
                    '/api/print/billing/document/' +
                    movement_.id
                );
              }
            });
          } else {
            Swal.fire({
              title: 'EN HORA BUENA!',
              html:
                '<b>Venta registrada correctamente</b>, desea imprimir el comprobante?',
              icon: 'success',
              showCancelButton: true,
              confirmButtonColor: '#30419b',
              confirmButtonText: 'Imprimir <i class="fas fa-print m-r-5"></i>',
              cancelButtonText: 'Cancelar'
            }).then(result => {
              if (result.isConfirmed) {
                window.open(
                  this.branchofficeSlug +
                    '/api/print/billing/document/' +
                    movement_.id
                );
              }
            });
          }

          this.cancel();
        }
      });
    }
  }

  saveHotelBooking() {
    if (this.validate()) {
      let options = {
        title: '¿Estás segur@?',
        message:
          'Esta seguro(a) de asociar la venta a la RESERVA DE HOTEL ASOCIADA ?',
        cancel: 'Cancelar',
        confirm: 'Sí, CONFIRMAR VENTA !'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.movement.client_default = this.client_default;
          this.movement.text_amount = this.amountTextService.letras(
            this.total_sale
          );
          this.item.patchValue({
            client_id: this.hotelBookingSelected.booking_data.client_id,
            bookinghotel_id: this.hotelBookingSelected.booking_data.id,
            detailbedroom_id: this.hotelBookingSelected.id,
            igv: this.total_igv,
            subtotal: this.subtotal,
            total: this.total_sale
          });

          let data: any = {};
          data.sale = this.item.value;
          data.paid = this.movement;
          data.detail = this.details;

          console.log(data);

          this.salesService.saveHotelBooking(data).subscribe({
            next: (result: any) => {
              console.log('after booking sale');
              this.alertifyMsg.success('Venta registrada con éxito');
              this.cancel();
            }
          });
        }
      });
    }
  }

  validate() {
    if (this.details.length === 0) {
      let options = {
        title: 'Advertencia !',
        message: 'Debe ingresar por lo menos un producto al detalle'
      };
      this.alert.warning(options);
      return false;
    } else {
      for (let i in this.details) {
        let product = this.details[i];
        if (Number(product.quantity) == 0 || _.isNull(product.quantity)) {
          this.alertifyMsg.warning(
            'La cantidad del producto ' +
              product.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#quantity' + i)).focus();
          return false;
        }

        if (Number(product.price) == 0 || _.isNull(product.price)) {
          this.alertifyMsg.warning(
            'El precio del producto ' +
              product.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#price' + i)).focus();
          return false;
        }
      }
    }

    if (this.total_sale == 0) {
      let options = {
        title: 'Advertencia !',
        message: 'El total de la venta no puede ser igual a cero'
      };
      this.alert.warning(options);
      return false;
    }

    if (this.hotelBookingSelected == null) {
      if (_.isNull(this.item.value.client_id)) {
        this.alertifyMsg.warning('Debe seleccionar el cliente para la venta');
        this.SearchClientComponent.focused();
        return false;
      }
    }

    return true;
  }

  setClientDefault() {
    if (this.client_default) {
      this.clientSelected = constants.CLIENT.DEFAULT;
      this.item.patchValue({
        client_id: constants.CLIENT.DEFAULT.id
      });
    } else {
      this.removeClientDefault();
    }
  }

  removeClientDefault() {
    this.isClientSelected = false;
    this.clientSelected = {};
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  changeOriginSale() {
    let value_ = null;
    if (this.item.value.origin_id == this.originsale_virtual) {
      value_ = this.virtualchannels[0].id;
    }
    this.item.patchValue({
      channel_id: value_
    });
  }

  changeTypeVoucher() {
    this.getSerieVoucher(this.movement.typevoucher_id);
    if (this.movement.typevoucher_id == this.typevoucher_factura.id) {
      this.client_default = false;
      this.removeClientDefault();
    }
  }

  changePaymentMethod() {
    let obj_ = this.toolsService.searchArrById(
      this.movement.paymentmethod_id,
      this.paymentmethods
    );
    this.paymentMethodSelected = obj_;

    if (!this.paymentMethodSelected.associate_bank) {
      this.movement.accountbank_id = null;
      this.movement.reference_operation = null;
    }
  }

  resetSearchAction() {
    this.page = 1;
    this.textSearchProduct = null;
    this.searchAction();
  }

  changeToPaid() {
    (<any>$('#boxProduct')).hide(
      'slide',
      { direction: 'right' },
      50,
      function() {
        (<any>$('#boxPaid')).css('display', 'block');
        (<any>$('.btnsBoxDetail')).css('display', 'none');
      }
    );
    this.movement.is_paid = true;
  }

  changeToProduct() {
    let component_ = this.thisComponent;
    (<any>$('#boxPaid')).hide('slide', { direction: 'right' }, 50, function() {
      (<any>$('#boxProduct')).css('display', 'block');
      (<any>$('.btnsBoxDetail')).css('display', 'block');
      component_.resetSearchAction();
    });
    this.movement.is_paid = false;
  }

  cleanSale() {
    let options = {
      title: '¡Cuidado!',
      message: 'Está por cancelar todo el progreso de la venta.',
      cancel: 'Minimizar',
      confirm: 'Cancelar Venta'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.cancel();
      }
    });
  }

  extendsHotelBookings(event: any): void {
    console.log(event);
    this.hotelBookingSelected = event;
  }

  removeBookHotel(): void {
    this.hotelBookingSelected = null;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/ventas/ventas/lista']);
  }
}
